import Slider from '../Elements/Slider';

/**
 * MediaSlider
 */
const MediaSlider = (() => {
	/**
	 * MediaSlider
	 *
	 * @var { Object }
	 */
	const Selector = {
		MEDIA_SLIDER: '.media-slider > .owl-carousel',
		MEDIA_FANCYBOX: '.media-element [data-fancybox="mediaslider"]'
	};

	/**
	 * MediaSlider
	 *
	 * @class
	 * @augments Slider
	 */
	class MediaSlider extends Slider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this._bindHandlers();

			this.initialize({
				margin: 30,
				responsive: {
					0: {
						margin: 15
					},
					640: {
						margin: 30
					}
				}
			});
		}

		// Private

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			let _self = this;
			let slideIndex,
				visible;

			this.$element.on('initialized.owl.carousel translated.owl.carousel', function (e) {
				slideIndex = e.item.index;
				visible = parseInt(e.page.size);
			});

			this.$element.find(Selector.MEDIA_FANCYBOX).fancybox({
				animationEffect: 'fade',
				animationDuration: 500,
				beforeShow: function (e) {
					if (e.currIndex == slideIndex + 4 || e.currIndex <= slideIndex) {
						_self.$element.trigger("to.owl.carousel", e.currIndex);
					}
				}
			});
		}
	}

	return MediaSlider._getElements(Selector.MEDIA_SLIDER, MediaSlider);
})();

export default MediaSlider;
